export default "__VITE_ASSET__9aec2248__$_?component__"